import { Avatar, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router";
import { Link } from "react-router-dom";
import { DefaultButton } from "../../../components/form";
import { IMAGES_PATH } from "../../../constants";
import { APP_COLORS } from "../../../enums";
import { ROUTE_PATHS } from "../../../routes/paths";
import { isDesktop, isMobile } from "react-device-detect";

const buttonStyles = {
  height: 84,
  width: isDesktop ? 311 : "100%",
  justifyContent: "flex-start",
  pl: 2,
  color: APP_COLORS.secondaryDark,
  fontWeight: 400,
  "&:hover": {
    borderColor: APP_COLORS.secondaryDark,
    boxShadow: `0px 2px 2px ${APP_COLORS.greyLight6}`,
  },
};

export default function Signup() {
  const navigate = useNavigate();
  const { setPageConfig }: any = useOutletContext();
  useEffect(() => {
    setPageConfig({ title: "" });
  }, []);

  const onTypeSelect = (value) => {
    if (value === "ambassador") navigate(ROUTE_PATHS.AUTH.SIGNUP_AMBASSADOR);
    if (value === "vendor") navigate(ROUTE_PATHS.AUTH.SIGNUP_VENDOR);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} container spacing={2}>
        <Grid item xs={12} sm={6}>
          <DefaultButton fullWidth={isMobile} startIcon={<Avatar sx={{ width: 64, height: 64, }}>
            <img src={`${IMAGES_PATH}/ambassador-signup.png`} />
          </Avatar>} onClick={() => onTypeSelect("ambassador")} sx={buttonStyles}>
            Sign up as an Ambassador
          </DefaultButton>
        </Grid>
        <Grid item xs={12} sm={6} mb={2}>
          <DefaultButton fullWidth={isMobile} startIcon={<Avatar sx={{ width: 64, height: 64 }}>
            <img src={`${IMAGES_PATH}/vendor-signup.png`} />
          </Avatar>} onClick={() => onTypeSelect("vendor")} sx={buttonStyles}>
            Sign up as a Vendor
          </DefaultButton>
        </Grid>
        <Grid item xs={12} textAlign={"center"}>
          <Typography variant="body-ibmPlexMono">Already have an account?</Typography>
          <Link to={ROUTE_PATHS.AUTH.LOGIN} color={APP_COLORS.secondary} style={{ textDecoration: "none" }}>
            <Typography
              sx={{ ml: 1, cursor: "pointer", borderRadius: "10px" }}
              variant="body-ibmPlexMono-medium"
              color={APP_COLORS.secondaryDark}
            >
              Sign In
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
}
